<template>
  <bean-source-page
    class="page-custom-page"
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.customPage')"
    resource="custom_pages"
    :before-submit="beforeSubmit"
    :actionButtons="[]"
    :onFetchData="fetchData"
  >

    <template #action>
      <bean-dialog-form
        :title="$t('bean.actionNew') + $t('model.customPage')"
        :columns="createColumns"
        v-model="createForm"
        :submit-handler="handleCreatePage"
      >
        <el-button type="primary">{{$t('bean.actionNew')}}</el-button>
      </bean-dialog-form>
    </template>

    <template v-slot:form-action="{ value }">
      <template v-if="value.id">
        <el-button type="warning" @click="handlePreview" :loading="previewing">{{$t('customPage.preview')}}</el-button>
        <el-popconfirm
          :title="$t('bean.actionConfirm') + $t('customPage.publish') + '？'"
          @onConfirm="handlePublishAtFormPage(value.id)"
          style="margin-left: 10px;"
        >
          <el-button slot="reference" type="danger">{{$t('customPage.publish')}}</el-button>
        </el-popconfirm>
      </template>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import qs from 'qs';
import _ from 'lodash';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/custom_pages.js';

@Component
export default class CustomPages extends Vue {
  @Prop(String) type;

  form = {}
  formData = {};
  linkTypes = [];
  previewing = false;
  customProducts = [];

  createForm = {};

  get createColumns() {
    const array = [
      'title',
      'slug',
    ];

    return formColumnsExtend(array, { data: this.createForm, type: 'new' })
  }

  tryParseJSON(str, defaultVal = {}) {
    let obj;
    try {
      obj = JSON.parse(str);
    } catch (e) {
      obj = defaultVal;
    }
    return obj;
  }

  async fetchData({ resource, type, namespace }) {
    if (this.type === 'edit') {
      const res = await Promise.all([
        this.$request.get('/page_links/types'),
      ])
      this.linkTypes = res[0].map(val => ({ value: val, label: val }));
    }
    if (type === 'index') {
      const { data, pagination } = await this.$request.get(`/${namespace}${resource}`, { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }
    if (type === 'edit' || type === 'show') {
      const data = await this.$request.get(`/${namespace}${resource}/${this.$route.params.id}`);
      return {
        data: {
          ...data,
          configs: this.tryParseJSON(data.configs, { components: [], config: {}, style: {} })
        }
      }
    }
  }

  async handleCreatePage(data) {
    const res = await this.$request.post('/custom_pages', this.transformFormSubmitData(data));
    this.$message.success('createSuccess');
    this.$router.push({ name: 'custom_pages.edit', params: { id: res.id } });
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'title_cont',
      'slug_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      'slug',
      'default',
      'mini_program_path',
      'created_at',
      'updated_at'
    ].filter(Boolean)

    return columnsExtend(array)
  }

  async handleLoadPages(node, resolve) {
    const { level, value } = node;
    if (level === 0) {
      resolve(this.linkTypes);
      return;
    }
    if (level === 1) {
      const { data } = await this.$request.get('/page_links', { params: { type: value, page: 0 } });
      resolve(data.map(item => ({ label: Object.keys(item)[0], value: Object.values(item)[0], leaf: true })));
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { type, data }) {
    this.formData = data;

    const array = [
      'title',
      'slug',
      {
        key: 'configs',
        renderCell: {
          component: 'pageGenerator',
          props: {
            useComponents: [
              'text',
              'title',
              'image',
              'multiple-image',
              'video',
              'swiper',
              'split-line',
              'blank',
              'scroll-x',
              'navbar',
              'form',
              'popup',
            ],
            pages: (h, context) => {
              return <el-cascader
                // 同步数据给event
                {...context}
                filterable
                clearable
                props={{ props: { emitPath: false, lazy: true, lazyLoad: this.handleLoadPages } }}
              />
            }
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  transformFormSubmitData(data) {
    return {
      ...data,
      configs: data.configs ? JSON.stringify(data.configs) : undefined
    }
  }

  beforeSubmit({ state: { data } }) {
    return this.transformFormSubmitData(data);
  }

  handleSave() {
    return this.$autoLoading(
      this.$request.put(`/custom_pages/${this.formData.id}`, this.transformFormSubmitData(this.formData))
    );
  }

  async handlePreview() {
    await this.handleSave();
    this.previewing = true;
    try {
      const params = {
        path: 'pages/extra/custom-page',
        binary: true,
        scene: qs.stringify({
          slug: this.slug,
          is_preview: true
        })
      }
      const resBlob = await this.$request.get('wechat_third_party_platform/utils/mini_program_qrcode', { params }, { responseType: 'blob', $alert: false });
      const qrcodeUrl = window.URL.createObjectURL(resBlob);
      this.$msgbox({
        title: this.$t('customPage.preview'),
        message: this.$createElement('el-image', { props: { src: qrcodeUrl } }),
        showCancelButton: false,
        confirmButtonText: this.$t('close'),
      });
    } catch (e) {
      const result = _.get(e, 'response.data');
      if (result instanceof Blob && result.type === 'application/json') {
        result.text().then(res => {
          const { error_message } = JSON.parse(res);
          this.$msgbox.alert(error_message, { title: this.$t('error') });
        });
        return;
      }
      this.$msgbox(e.message, { title: this.$t('error') })
    } finally {
      this.previewing = false;
    }
  }

  async handlePublishAtFormPage(id) {
    await this.handleSave();
    return this.handlePublish(id);
  }

  async handlePublish(id) {
    await this.$autoLoading(this.$request.post(`/custom_pages/${id}/publish`));
    this.$message.success(this.$t('operateSuccess'));
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'custom_pages.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('customPage.publish'),
          type: 'success',
          can: 'custom_pages.publish',
        },
        on: {
          confirm: () => this.handlePublish(row.id)
        }
      },
      !row.default && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'custom_pages.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/custom_pages',
    name: 'custom_pages.index',
    component: CustomPages,
    props: {
      type: 'index',
    }
  },
  {
    path: '/custom_pages/:id',
    name: 'custom_pages.show',
    component: CustomPages,
    props: {
      type: 'show',
    }
  },
  {
    path: '/custom_pages/:id/edit',
    name: 'custom_pages.edit',
    component: CustomPages,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style lang="scss" scoped>
  .page-custom-page {
    /deep/ .source-page-form > .page-content > .el-form {
      width: 100%;
      min-width: unset;
    }
  }
</style>
